<template lang="pug">
.container-dialog
  el-header(height='40px')
    span {{$t('Create Device Template from ')}}
    span.bolder {{ device.name }}
    hr.header
  el-input(id="CreateDeviceTemplate-templateNameInput" v-model='deviceLocal.name', value='device.name')
    template(slot='prepend') {{ $t('Template name')}}
  el-button.float-right(
    id="CreateDeviceTemplate-createButton",
    type="success",
    :disabled="isSaving",
    size="small",
    @click="createTemplate()"
  )
    font-awesome-icon(icon="magic")
    span &nbsp; {{$t(buttonSaveText())}}
  div.error(v-if="errors.length > 0") {{$t('Cannot create Device Template')}}
  .errors(v-if="errors.length > 0")
    .error(v-for="error in errors")
      p {{ error }}
  br
  br
</template>

<script>
import Vue from 'vue'

export default {
  components: {
  },
  props: ['side', 'device'],
  data () {
    return {
      errors: {
      },
      isSaving: false,
      loading: false,
      deviceLocal: {
        name: ''
      }
    }
  },
  async created () {
    this.deviceLocal.name = this.device.name
  },
  watch: {

  },
  methods: {
    async __validateInput () {
      return true
    },
    async createTemplate () {
      const valid = await this.__validateInput()
      if (!valid) return
      this.isSaving = true
      let path = 'DeviceTemplate/createDeviceTemplateFromDevice'
      await Vue.axios.post(path, { deviceId: this.device.id, name: this.deviceLocal.name })
        .then(response => {
          this.$emit('closeCreateDeviceTemplate')
        })
      this.isSaving = false
    },
    buttonSaveText () {
      if (this.isSaving) return 'saving data...'
      return 'Create Device Template'
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/CreateDeviceTemplate.vue